import Checkbox from '@polestar/component-warehouse-react/components/checkbox/Checkbox';
import React, { forwardRef, useCallback, useRef } from 'react';
import FormField from '@polestar/component-warehouse-react/components/form-field/FormField';
import { useFocusTriggers } from '@polestar/component-warehouse-react/hooks/useFocusTriggers';
import useCombinedRef from '@polestar/component-warehouse-react/hooks/useCombinedRef';
import Orientations from '@polestar/component-warehouse-react/tokens/orientations/Orientations';
import { useSSRSafeId } from '@polestar/component-warehouse-react/contexts/ssr';
import warnOnce from '@polestar/component-warehouse-react/helpers/warnOnce';
const CheckboxField = forwardRef(({ onChange, onFocus, onBlur, checked, errorMessage, error, hint, trailing, label, name, value, fieldProps, minimalHitboxType, tooltip, monochrome, ...props }, ref) => {
    const internalRef = useRef(null);
    const combinedRef = useCombinedRef(ref, internalRef);
    const memoizedId = useSSRSafeId('checkbox-field', props.id);
    const memoizedFieldId = `${memoizedId}-container`;
    const { focused, focusBlurEvents } = useFocusTriggers({
        name,
        onFocus,
        onBlur,
    });
    const handleChange = useCallback((e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked, name);
    }, [onChange, name]);
    const isStringLabel = typeof label === 'string';
    const labelContent = isStringLabel && !!props.required ? (React.createElement(React.Fragment, null,
        label,
        React.createElement("span", { "aria-hidden": true }, "\u00A0*"))) : (label);
    if (!isStringLabel && props.required) {
        warnOnce('checkbox-asterisk', '[Checkbox] ensure yourself to add an * (asterisk) when this field is required, because the provided label is not a string but a ReactElement.');
    }
    return (React.createElement(FormField, { ...fieldProps, errorMessage: errorMessage, error: error, hint: hint, border: false, disabled: props.disabled, required: props.required, trailing: trailing, focused: focused, id: memoizedFieldId, forId: memoizedId, minHeight: false, isTextInput: false, tooltip: tooltip, tooltipPosition: Orientations.horizontal },
        React.createElement(Checkbox, { ref: combinedRef, ...props, ...focusBlurEvents, type: "checkbox", checked: checked, error: !!errorMessage || !!error, errorLabel: errorMessage === true, 
            // TODO: RTL support needs to flip this *?
            label: labelContent, name: name, id: memoizedId, value: value, onChange: handleChange, minimalHitboxType: minimalHitboxType, monochrome: monochrome })));
});
CheckboxField.displayName = 'CheckboxField';
export default CheckboxField;
